import { useState } from 'react';
import { Typography, Box } from '@mui/material';
import { useDialog } from '../../shared/hook/useDialog';
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox';
import CustomDivider from '../../shared/utils/CustomDivider';
import { TermAndConditionList } from '../../assets/api/useMarketingExecutive';
import { TextSkeleton } from '../../shared/utils/SkeletonCom';
import MarketingTable from '../../features/commonfile/MarketingTable';
import CommonTermAndConditionTable from '../../features/commonfile/CommonTermAndConditionTable';
import PayoutTable from '../../features/commonfile/PayoutTable';
import CommonContactPersonTable from '../../features/commonfile/CommonContactPersonTable';
import { NormalContainerWithHeader } from '../components/student/NormalComponent';



export const useApartmentColumnsWithDialog = () => {

  const [selectedRow, setSelectedRow] = useState({});

  const { open, handleClickOpen, handleClose } = useDialog();

  const { data: termConditionList, isLoading: isLoadingTerms } = TermAndConditionList({
    apartment_id: selectedRow?.id
  });

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "accepted by apartment": return "green";
      case "approved by manager": return "#ff9900";
      case "created": return "#ffdb4d";
      case "not created": return "grey";
      case "rejected": return "red";
      default: return "black";
    }
  };

  const viewApartment = (row) => {
    setSelectedRow(row);
    handleClickOpen();
  };

  const apartmentColumns = [
    {
      field: "sr_no", headerName: "Sr No", flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
    },
    {
      field: "apartment_name", headerName: "Apartment Name", flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
    },
    // {
    //   field: "terms_status", headerName: "Term Status", flex: 1,
    //   renderCell: (params) => (
    //     <Typography variant="body2" color={getStatusColor(params.value)}>
    //       {params.value}
    //     </Typography>
    //   )
    // }
  ];

  const dialogJSX = (

    <MainDialogBox open={open} handleClose={handleClose} width={"60%"}>
      <CustomDivider />
      {isLoadingTerms ? (
        <TextSkeleton line={5} />
      ) : (
        <Box>


          <NormalContainerWithHeader headerText={"Contact Person List"}>
            <CommonContactPersonTable id={selectedRow?.id} />
          </NormalContainerWithHeader>


          <CustomDivider/>



          {termConditionList?.terms_history?.length > 0 ? (
            <>
              {termConditionList?.terms_history?.length > 0 && (
                <>
                  {/* <Typography variant="h5" mb={1}>Term History</Typography> */}
                  <CommonTermAndConditionTable id={selectedRow?.id} />
                  <CustomDivider />
                </>
              )}

              {termConditionList?.student_payouts?.length > 0 && (
                <>
                  {/* <Typography variant="h5" mb={1}>Payouts</Typography> */}
                  <PayoutTable id={selectedRow?.id} />
                  <CustomDivider />
                </>
              )}

              {termConditionList?.marketing_ads?.length > 0 && (
                <>
                  {/* <Typography variant="h5" mb={1}>Marketing Ads</Typography> */}
                  <MarketingTable id={selectedRow?.id} />
                  <CustomDivider />
                </>
              )}
            </>
          ) : (
            <Typography>No Detail</Typography>
          )}
        </Box>
      )}
    </MainDialogBox>

  );

  return { apartmentColumns, viewApartment, dialogJSX };
};
